import type { IntakeFormPayload } from "@/features/billing/api";
import type { FunnelIntakeAnswers } from "../models";
import { SKIPPED_ANSWER } from "../models";
import type { FunnelStore } from "../stores";

const withoutSkipped = (answers: FunnelIntakeAnswers): FunnelIntakeAnswers =>
  Object.fromEntries(
    Object.entries(answers).filter(([, answer]) => answer !== SKIPPED_ANSWER),
  );

export const funnelCheckoutIntake = ({
  intakeAnswers,
}: Pick<FunnelStore, "intakeAnswers">): IntakeFormPayload | undefined =>
  intakeAnswers && Object.keys(intakeAnswers).length > 0
    ? { funnelAnswers: withoutSkipped(intakeAnswers) }
    : undefined;
